// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__k9F7A","invert":"Button_invert__lL4e0"};